import { create } from 'zustand'
import { useEffect } from 'react'

interface PageTitleStore {
  title: string
  setTitle: (title: string) => void
}

export const usePageTitleStore = create<PageTitleStore>((set) => ({
  title: '',
  setTitle: (title: string) => set({ title }),
}))

/**
 * Hook for pages to set the header title.
 * Automatically clears on unmount.
 */
export function usePageTitle(title: string) {
  const setTitle = usePageTitleStore((s) => s.setTitle)
  useEffect(() => {
    setTitle(title)
    return () => setTitle('')
  }, [title, setTitle])
}
